
import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';
import { FileIconType } from '@uifabric/file-type-icons/lib/index';
import { Histogram, ProgressPhase } from '../facets/ProgressFacets';
import { ICommand } from '../models/commands/ICommand';

/**
 * @public
 */
export interface IProgressIconProps {
  extension?: string;
  isOneNote?: boolean;
  isFolder?: boolean;
  type?: FileIconType;
}

/**
 * @public
 */
export const progressControl = new ControlFacet<{
  itemKey: string;
  itemCountsByPhase: Histogram<ProgressPhase>;
  format: 'item' | 'group' | 'summary';
}, {
  title: React.ReactNode;
  description: React.ReactNode;
  percentComplete: number | undefined;
  commands: ICommand[];
  errorKey: string;
}>('progress');
